<template>
  <li class="group-card-skeleton">
    <div class="group-card-skeleton__left">
      <b-skeleton class="group-card-skeleton__item group-card-skeleton__title" />

      <div class="group-card-skeleton__list">
        <b-skeleton class="group-card-skeleton__item group-card-skeleton__list-item" />
        <b-skeleton class="group-card-skeleton__item group-card-skeleton__list-item" />
        <b-skeleton class="group-card-skeleton__item group-card-skeleton__list-item" />
      </div>

      <b-skeleton class="group-card-skeleton__item group-card-skeleton__more" />
    </div>

    <div class="group-card-skeleton__right">
      <b-skeleton class="group-card-skeleton__item group-card-skeleton__img" />
    </div>
  </li>
</template>

<script>
export default {
  name: 'ProductGroupCardSkeleton',
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common-imports.scss';

.group-card-skeleton {
  background-color: $White;

  display: grid;
  grid-template-columns: 1fr 40px;
  column-gap: 8px;
  padding: 12px;
  border-radius: 12px;

  @include media-breakpoint-up(sm) {
    grid-template-columns: 1fr 50px;
    column-gap: 16px;
    border-radius: 16px;
    padding: 16px;
  }

  &__item {
    margin: 0;
  }

  &__title {
    margin-bottom: 14px;
    height: 16px;
    width: 80%;

    @include media-breakpoint-down(xs) {
      width: 100%;
    }
  }

  &__list {
    display: grid;
    gap: 6px;
  }

  &__list-item {
    height: 14px;

    &:first-child {
      width: 60%;
    }

    &:nth-child(2) {
      width: 45%;
    }

    &:nth-child(3) {
      width: 30%;
    }
  }

  &__more {
    margin-top: 16px;
    height: 14px;
    width: 50px;
  }

  &__right {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  &__img {
    width: 40px;
    height: 40px;
    border-radius: 16px;

    @include media-breakpoint-up(sm) {
      width: 50px;
      height: 50px;
    }
  }
}
</style>
